import Processes from "./views/Processes.vue";
import ProcessEditor from "./views/ProcessEditor.vue";

const moduleRoutes = [
	{
		path: "/:domainId/template/processes",
		name: "Processes",
		component: Processes,
	},

	{
		path: "/:domainId/template/processes/:processId",
		name: "Process Editor",
		component: ProcessEditor,
	},
];

export default moduleRoutes;
